import axios from 'axios';
import _ from 'lodash';

import i18n from '@/i18n/index';
import { logException } from '@/utils/exception_handler';

export function post(endpoint, data) {
  return axios.post(endpoint, data);
}

export function put(endpoint, data) {
  return axios.put(endpoint, data);
}

export function putWithHeaders(endpoint, data, headers) {
  return axios.put(endpoint, data, { headers });
}

export function get(endpoint, params) {
  return axios.get(endpoint, { params });
}

export function destroy(endpoint) {
  return axios.delete(endpoint);
}

export function blobToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onloadend = () => {
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };
  });
}

export function parseSuccess(response) {
  return response.data;
}

export const parseError = (error) => {
  let parsedError = null;

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    if (_.get(error, 'response.data.errors.full_messages')) {
      parsedError = error.response.data.errors.full_messages;
    } else if (_.get(error, 'response.data.errors')) {
      parsedError = error.response.data.errors;
    } else {
      parsedError = error.response.data;
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    logException(error);

    parsedError = i18n.t('messages.requestError');
  } else {
    // Something happened in setting up the request that triggered an Error
    logException(error);

    parsedError = i18n.t('messages.exception');
  }

  return parsedError;
};



// WEBPACK FOOTER //
// ./src/api/request.js